<script setup lang="ts">
const { isMobile } = useBreakpoint()
const footerIsInViewport = useState('footer-in-viewport', () => false)

defineSlots<{ default(): any }>()
</script>

<template>
  <div v-if="isMobile ? !footerIsInViewport : true" class="sticky-bottom">
    <slot />
  </div>
</template>

<style>
.sticky-bottom {
  border-radius: 0.25rem 0.25rem 0 0;
  box-shadow:
    inset 0 1px 3px 0 #f5f7f8,
    0 -1px 4px 0 rgba(#202020, 0.2);
  @apply bg-white z-sticky w-full fixed left-0 bottom-0;
}
</style>
